export default "__VITE_ASSET__CmhHuk79__"